/**
 * This file contains the Unity WebGL callbacks declared in the WebGL app.
 */

type UCWindow = Window & typeof globalThis & {
    UCOrderReceived: (result: any) => void;
    UCOnLoadedReceived: () => void;
    UCViewChangedReceived: (key: string, value: string) => void;
    UCSelectedToBrowserReceived: (...args: any[]) => void;
    UCDimensionLabelsReceived: (...args: any[]) => void;
    UCDimensionPositionsReceived: (...args: any[]) => void;
}

export default UCWindow;
